const faqitems = [
    {
        key: '1',
        label: 'What are FAQ questions?',
        children: <p>An FAQ page <b>(short for Frequently Asked Question page)</b> is a part of your website that provides answers to common questions, assuages concerns, and overcomes objections. It's a space where customers away from your sales-focused landing pages and homepage.</p>,
    },
    {
        key: '2',
        label: 'What is FAQ process?',
        children: <p>FAQ stands for Frequently Asked Questions. It's <b>your opportunity to communicate with the most important visitors to your website</b> – those who have begun the decision-making process about whether to do business with you can't fit elsewhere on their website.</p>,
    },
    {
        key: '3',
        label: 'What is the purpose of FAQ?',
        children: <p>The purpose of a FAQ is generally to provide information on frequent questions or concerns; however, the format is a useful means of organizing information, and text consisting of questions and their answers may thus be called a FAQ regardless.</p>,
    },
    {
        key: '4',
        label: 'What is an online FAQ?',
        children: <p>FAQs stand for frequently asked questions. It is one of the many crucial pages of your website. It gives your customers answers to recurring and common questions and addresses their concerns public product documentation that is released at the same time.</p>,
    },
];

const faqdata = [
    {
        key: '1',
        label: 'What is account management process?',
        children: <p>If several languages coalesce, the grammar of the resulting language is more simple and regular than that of the individual languages. The new common language will be more simple and regular than the existing European languages. It will be as simple their most common words.</p>,
    },
    {
        key: '2',
        label: 'Why is account management important?',
        children: <p>The new common language will be more simple and regular than the existing European languages. It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is.</p>,
    },
    {
        key: '3',
        label: 'What is account manager role?',
        children: <p>The wise man therefore always holds in these matters to this principle of selection: he rejects pleasures to secure other greater pleasures, or else he endures pains to avoid worse pains.But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born.</p>,
    },
    {
        key: '4',
        label: 'What is a key account strategy?',
        children: <p>Cras ultricies mi eu turpis hendrerit fringilla. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Nam pretium turpis et arcu arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis aliquam ultrices mauris.</p>,
    },
]

const privacy = [
    {
        key: '1',
        label: 'Which is important privacy or security?',
        children: <p>If several languages coalesce, the grammar of the resulting language is more simple and regular than that of the individual languages. The new common language will be more simple and regular than the existing European languages. It will be as simple their most common words.</p>,
    },
    {
        key: '2',
        label: 'What is security and privacy?',
        children: <p>The new common language will be more simple and regular than the existing European languages. It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is.</p>,
    },
    {
        key: '3',
        label: 'How can I protect my privacy?',
        children: <p>The wise man therefore always holds in these matters to this principle of selection: he rejects pleasures to secure other greater pleasures, or else he endures pains to avoid worse pains.But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born.</p>,
    },
    {
        key: '4',
        label: 'Why is privacy so important?',
        children: <p>Cras ultricies mi eu turpis hendrerit fringilla. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In ac dui quis mi consectetuer lacinia. Nam pretium turpis et arcu arcu tortor, suscipit eget, imperdiet nec, imperdiet iaculis aliquam ultrices mauris.</p>,
    },
]

export { faqdata, faqitems, privacy }